import {assert} from 'Asserts';
import {getStructuredTableAdapters} from 'notebook/structured-tables/StructuredTableAdapters';
import {StructuredTableKind} from 'notebook/structured-tables/StructuredTableConstants';
import {EMPTY_PLACEHOLDER_INSERTION_CONTEXT} from 'notebook/structured-tables/util/StructuredTableInsertionContext';
import {
  getOutputSchema,
  ProcessOutputStructuredTable,
} from 'processes/tables/ProcessOutputStructuredTableAdapter';
import {getTaskSchema, ProcessTaskStructuredTable} from 'processes/tables/ProcessTaskStructuredTableAdapter';
import {Schema} from 'schemas/SchemaConstants';
import {SchemaFieldSelector} from 'schemas/SchemaFieldSelectorConstants';

/**
 * Creates a new read-only process table from an process existing table.
 * Read-only process tables are not editable and do not render any action buttons.
 */
export default function createReadOnlyProcessTable<
  T extends ProcessOutputStructuredTable | ProcessTaskStructuredTable,
>(table: T, selectorsById: {[id: string]: SchemaFieldSelector}): T {
  let schema;
  const adapter = getStructuredTableAdapters()[table.kind];
  if (table.kind === StructuredTableKind.PROCESS_TASK) {
    schema = getTaskSchema(table.schemas);
  } else if (table.kind === StructuredTableKind.PROCESS_OUTPUT) {
    schema = getOutputSchema(table.schemas);
  } else {
    assert(false, `Unexpected structured table kind ${table.kind}`);
  }
  assert(schema != null, 'Expected to find a process related schema on the table');
  const readOnlyTable = adapter.createTable({
    name: table.name,
    schemas: [{...(schema as Schema), columnGroup: null}],
    entryId: null,
    metadata: {...table.metadata, isReadOnly: true},
    selectorsById,
    structuredTableInsertionContext: EMPTY_PLACEHOLDER_INSERTION_CONTEXT,
  });
  readOnlyTable.columns = table.columns.map((column) => ({...column, isReadOnly: true}));
  readOnlyTable.rows = table.rows.map((row) => ({...row}));

  return {...readOnlyTable, cid: `${schema.id}-readonly`} as T;
}
